/* eslint-disable @typescript-eslint/ban-ts-comment */
import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill';

export async function intlRelativetimeformatPolyfill() {
  if (shouldPolyfill()) {
    await import('@formatjs/intl-relativetimeformat/polyfill');
  }

  // @ts-ignore
  if (Intl.RelativeTimeFormat.polyfilled) {
    // @ts-ignore
    await import('@formatjs/intl-relativetimeformat/locale-data/en');
  }
}
